// Components
import { USER_INTERACTION } from '../../../../constants/entityTypes';
import { SHOW_MORE_SUBSCRIBE_TYPE } from '../../../../constants/subscribeTypes';
import { ISubscriberInfo } from '../../../../types';
import { SMPFlex, SMPText } from '../../../index';
import { SMPArrowDownIcon } from '../../atoms/icons/SMPArrowDownIcon';
import { defaultHandleUserInteractionClick } from '@sportal365/smp-widget-utils/src/clickHandlers';

export interface IShowMoreProps {
  handleShowMoreClick?: () => void;
  showMoreLabel?: string;
  totalItems: number;
  showedItems: number;
  handleSubscriptionClick?: (info: ISubscriberInfo, clickType: string) => void;
}

export const ShowMore = ({
  handleShowMoreClick,
  showMoreLabel,
  totalItems,
  showedItems,
  handleSubscriptionClick,
}: IShowMoreProps): JSX.Element => {
  const showMore = showMoreLabel ?? 'Show more';

  const handleShowMoreClickAndSendSubscriptionEvent = () => {
    if (!handleShowMoreClick) {
      return;
    }

    handleShowMoreClick();
    handleSubscriptionClick && defaultHandleUserInteractionClick(handleSubscriptionClick, USER_INTERACTION, SHOW_MORE_SUBSCRIBE_TYPE);
  };

  return (
    <>
      {totalItems && showedItems && totalItems > showedItems ? (
        <SMPFlex
          justify='center'
          align='center'
          css={{
            backgroundColor: '$rowBackgroundColor',
          }}
        >
          <SMPFlex onClick={handleShowMoreClickAndSendSubscriptionEvent} variant='showMore'>
            <SMPText variant='showMore'>{showMore}</SMPText>
            <SMPArrowDownIcon />
          </SMPFlex>
        </SMPFlex>
      ) : null}
    </>
  );
};
